// extracted by mini-css-extract-plugin
module.exports = {"tags":"s-module--tags--Sln7P","tag":"s-module--tag--3HIHT"};